'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.queryDocumentsSaga = queryDocumentsSaga;

var _effects = require('redux-saga/effects');

var _reduceLoading = require('../../actions/context/reduceLoading');

var _reduceLoading2 = _interopRequireDefault(_reduceLoading);

var _reduceOperation = require('../../actions/context/reduceOperation');

var _reduceOperation2 = _interopRequireDefault(_reduceOperation);

var _reduceDocuments = require('../../actions/document/reduceDocuments');

var _reduceDocuments2 = _interopRequireDefault(_reduceDocuments);

var _selectDocumentQuery = require('../../selectors/document/selectDocumentQuery');

var _selectSession = require('../../selectors/context/selectSession');

var _selectSubfolderPrefix = require('../../selectors/context/selectSubfolderPrefix');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(queryDocumentsSaga);

function queryDocumentsSaga() {
	var session, query, subfolderPrefix, response, result;
	return regeneratorRuntime.wrap(function queryDocumentsSaga$(_context) {
		while (1) {
			switch (_context.prev = _context.next) {
				case 0:
					_context.next = 2;
					return (0, _effects.put)((0, _reduceLoading2.default)(true));

				case 2:
					_context.next = 4;
					return (0, _effects.select)((0, _selectSession.selectSession)());

				case 4:
					session = _context.sent;
					_context.next = 7;
					return (0, _effects.select)((0, _selectDocumentQuery.selectDocumentQuery)());

				case 7:
					query = _context.sent;
					_context.next = 10;
					return (0, _effects.select)((0, _selectSubfolderPrefix.selectSubfolderPrefix)());

				case 10:
					subfolderPrefix = _context.sent;
					_context.next = 13;
					return (0, _effects.call)(fetch, subfolderPrefix + '/api/document/query', {
						method: 'POST',
						credentials: 'same-origin',
						headers: {
							'Accept': 'application/json',
							'Authorization': session.authenticationToken.token,
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({ documentQuery: _extends({}, query) })
					});

				case 13:
					response = _context.sent;
					_context.next = 16;
					return (0, _effects.call)([response, 'json']);

				case 16:
					result = _context.sent;
					_context.next = 19;
					return (0, _effects.put)((0, _reduceOperation2.default)(result.operation));

				case 19:
					if (result.operation.status) {
						_context.next = 23;
						break;
					}

					_context.next = 22;
					return (0, _effects.put)((0, _reduceLoading2.default)(false));

				case 22:
					return _context.abrupt('return');

				case 23:
					_context.next = 25;
					return (0, _effects.put)((0, _reduceDocuments2.default)(result.documents));

				case 25:
					_context.next = 27;
					return (0, _effects.put)((0, _reduceLoading2.default)(false));

				case 27:
				case 'end':
					return _context.stop();
			}
		}
	}, _marked, this);
}